import React, { useState } from "react";
import { Award } from "lucide-react";
import { downloadCertificate } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";

export function CertificateButton({ cert, className = "", size = "sm", testid = "download-certificate" }) {
  const [busy, setBusy] = useState(false);
  const go = async () => {
    setBusy(true);
    try { await downloadCertificate(cert); } catch { toast.error("Could not download certificate"); }
    setBusy(false);
  };
  return (
    <Button size={size} onClick={go} disabled={busy} className={`viriks-amber text-white font-semibold ${className}`} data-testid={testid}>
      <Award size={15} className="mr-1" /> {busy ? "Preparing..." : "Certificate"}
    </Button>
  );
}

export function ProgressBar({ value, dark = false, testid }) {
  return (
    <div className="flex items-center gap-2" data-testid={testid}>
      <div className={`h-1.5 flex-1 rounded-full overflow-hidden ${dark ? "bg-white/15" : "bg-muted"}`}>
        <div className="h-full bg-crimson transition-[width] duration-500" style={{ width: `${value}%` }} />
      </div>
      <span className={`text-xs font-semibold tabular-nums ${dark ? "text-white/70" : "text-muted-foreground"}`}>{value}%</span>
    </div>
  );
}
